var productLinePage = {
  sliderSelector: ".multi-prod-families",
  breakpoint: 768,
  stopInit: false,
  init: function () {
    this.boxFamilies();
    this.familiesSlider();
    this.proconsMobile();
    this.textImageMobilAccordion();
    linePageNav.init();
  },
  familiesSlider: function () {
    let obj = this;
    if ($(`${this.sliderSelector}`).length > 0) {
      $(`${this.sliderSelector}`).each(function () {
        if (
          $(this)
            .find(".swiper-container")
            .hasClass("swiper-container-initialized")
        )
          return;

        let swiper = new Swiper(
          this.querySelector(`${obj.sliderSelector} .swiper-container`),
          {
            init: false,
            spaceBetween: 0,
            slidesPerView: 3.5,
            allowTouchMove: true,
            freeMode: true,
            mousewheel: true,
            keyboard: true,
            centeredSlidesBounds: true,
            centeredSlides: true,
            watchSlidesVisibility: true,
            mousewheel: false,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            scrollbar: {
              el: ".swiper-scrollbar",
              draggable: true,
              dragSize: 200,
              dragClass: "swiper-scrollbar-drag",
            },
          }
        );
        swiper.on("resize", function () {
          // do something
          if ($(window).width() <= obj.breakpoint) {
            swiper.destroy();
          }
        });

        // init Swiper
        if ($(window).width() > obj.breakpoint) {
          swiper.init();
        }
      });
    }
    if (!this.stopInit) {
      $(window).on("resize", function () {
        if ($(window).width() > obj.breakpoint) {
          obj.familiesSliderCheck();
        }
      });
      this.stopInit = true;
    }
  },
  familiesSliderCheck: function () {
    // Reinit slider from mobile to desktop size
    const $container = $(`${this.sliderSelector} .swiper-container`);
    if (!$container.hasClass("swiper-container-initialized")) {
      this.familiesSlider();
    }
  },
  boxFamilies: function () {
    var mainClass = ".multi-prod-families",
      $btns = $(mainClass + "__fam-list a"),
      $wrap = $(mainClass + "__ajax-wrap"),
      $btnsWrap = $(mainClass + "__fam-list");
    obj = this;

    $btns.first().addClass("selected");

    $btns.on("click", function (e) {
      e.preventDefault();

      var $el = $(this),
        link = $el.attr("href");

      $el
        .addClass("selected")
        .parents("li")
        .siblings()
        .find("a")
        .removeClass("selected");

      // Calls the collection template, with forced template in order to return the html snippet for this box
      $.ajax({
        url: link + "?view=families-block",
        beforeSend: function () {
          var wrapHeight = $wrap.outerHeight(true);

          $wrap.css({ height: wrapHeight }).addClass("ajax-loading");
        },
        success: function (data) {
          $wrap.find(".family-row").remove();
          $wrap.append(data).removeAttr("style");

          setTimeout(function () {
            $wrap.removeClass("ajax-loading");
          }, 150);

          obj.familiesSlider();

          var defaultOffset = $(window).width() <= 798 ? 45 : 70;
          defaultOffset += $(".page-dav-line-nav").outerHeight();
          goToPos(`${mainClass}`, defaultOffset);
        },
        error: function (data) {},
      });
    });
  },
  proconsMobile: function () {
    var $btns = $(".positive-negative__list-mobile-controls");

    $btns.on("click", function () {
      var $el = $(this);

      $el.parents(".row-lists").toggleClass("show-cons");
    });
  },

  textImageMobilAccordion: function () {
    var $btns = $(".text-image-mob-acc__oth-mob-toggle");

    $btns.on("click", function () {
      var $el = $(this);

      $el
        .parents(".text-image-mob-acc__oth-block")
        .toggleClass("open-accordion");
      setTimeout(function () {
        goToPos($el);
      }, 250);
    });
  },
};

var linePageNav = {
  selector: ".page-dav-line-nav",
  init: function () {
    var $bar = $(this.selector),
      self = this;

    if ($bar.length == 1) {
      this.checkBar();
      this.buttons();
      this.setBarTop();
      this.visibility();
      if (!this.stopInit) {
        $(window).on("resize", function () {
          self.checkBar();
        });
        this.stopInit = true;
      }
      $(window).on("scroll", function () {
        self.setBarTop();
      });
    }
  },
  checkBar: function () {
    var $list = $(this.selector + " ul"),
      $arrows = $(this.selector + "__scroll-icon"),
      barInnerWidth = 0,
      barOuterWidth = $list.outerWidth();

    $list.find("li").each(function () {
      barInnerWidth += $(this).outerWidth();
    });

    $arrows.toggle(barInnerWidth > barOuterWidth);
  },
  setBarTop: function () {
    var $bar = $(this.selector),
      $menu =
        $(window).outerWidth() >= 1024
          ? $(".main_nav_wrapper")
          : $("#header.mobile_nav-fixed--true");
    $bar.css({ top: $menu.outerHeight() });
  },
  buttons: function () {
    var $list = $(this.selector + " ul");
    $(this.selector + "__scroll-icon")
      .stop(true, true)
      .click(function () {
        var actualScroll = $list.scrollLeft(),
          verse = $(this).data("scroll"),
          scrollMultiplier = verse == "right" ? 1 : -1,
          stepWidth = $list.find("li").first().outerWidth();

        $list.animate(
          { scrollLeft: actualScroll + stepWidth * scrollMultiplier },
          300
        );
      });
  },
  visibility: function () {
    var $bar = $(this.selector),
      $block = $(".multi-prod-families");

    $block.waypoint(
      function (direction) {
        $bar.toggleClass("active", direction == "down");
      },
      {
        offset: "60%",
      }
    );
  },
};

//document ready
$(function () {
  productLinePage.init();
});
